import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NavigationComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c0 = function (a0, a1, a2, a3) { return [a0, a1, a2, a3]; };
function NavigationComponent_ng_container_1_div_4_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵelementStart(1, "a", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const qs_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const isFirst_r8 = ctx.first;
    const isLast_r9 = ctx.last;
    const isOdd_r10 = ctx.odd;
    const isEven_r11 = ctx.even;
    ɵngcc0.ɵɵclassMapInterpolate1("link link-", i_r7, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(6, _c0, isLast_r9 ? "last" : "", isFirst_r8 ? "first" : "", isOdd_r10 ? "odd" : "", isEven_r11 ? "even" : ""));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", qs_r6.link.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(qs_r6.link.title);
} }
function NavigationComponent_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "h2");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, NavigationComponent_ng_container_1_div_4_span_3_Template, 3, 11, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.quickLinksTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.quickLinks);
} }
function NavigationComponent_ng_container_1_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "a", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r13 = ctx.$implicit;
    const i_r14 = ctx.index;
    const isFirst_r15 = ctx.first;
    const isLast_r16 = ctx.last;
    const isOdd_r17 = ctx.odd;
    const isEven_r18 = ctx.even;
    ɵngcc0.ɵɵclassMapInterpolate1("link link-", i_r14, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(6, _c0, isLast_r16 ? "last" : "", isFirst_r15 ? "first" : "", isOdd_r17 ? "odd" : "", isEven_r18 ? "even" : ""));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", link_r13.link.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(link_r13.link.title);
} }
function NavigationComponent_ng_container_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "h3");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, NavigationComponent_ng_container_1_div_5_div_3_Template, 3, 11, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.linksTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.links);
} }
function NavigationComponent_ng_container_1_div_7_h2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r19.infoBox.title);
} }
function NavigationComponent_ng_container_1_div_7_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r20.infoBox.eMail);
} }
function NavigationComponent_ng_container_1_div_7_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r21.infoBox.tel);
} }
function NavigationComponent_ng_container_1_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "a", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r22.contact.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r22.contact.title);
} }
function NavigationComponent_ng_container_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, NavigationComponent_ng_container_1_div_7_h2_1_Template, 2, 1, "h2", 1);
    ɵngcc0.ɵɵtemplate(2, NavigationComponent_ng_container_1_div_7_p_2_Template, 2, 1, "p", 1);
    ɵngcc0.ɵɵtemplate(3, NavigationComponent_ng_container_1_div_7_p_3_Template, 2, 1, "p", 1);
    ɵngcc0.ɵɵtemplate(4, NavigationComponent_ng_container_1_div_7_div_4_Template, 3, 2, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.infoBox.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.infoBox.eMail);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.infoBox.tel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.contact.url);
} }
function NavigationComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtemplate(4, NavigationComponent_ng_container_1_div_4_Template, 4, 2, "div", 5);
    ɵngcc0.ɵɵtemplate(5, NavigationComponent_ng_container_1_div_5_Template, 4, 2, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵtemplate(7, NavigationComponent_ng_container_1_div_7_Template, 5, 4, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.quickLinks);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.links);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.infoBox.title || ctx_r1.infoBox.eMail || ctx_r1.infoBox.tel);
} }
class NavigationService {
    constructor() { }
}
NavigationService.ɵfac = function NavigationService_Factory(t) { return new (t || NavigationService)(); };
NavigationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(); }, token: NavigationService, providedIn: "root" });
NavigationService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavigationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class NavigationComponent {
    constructor() { }
    ngOnInit() {
        console.log('navigation');
        this.currentTemplate = this.initialTemplate;
        this.infoBox = this.navigation.infoBox;
        this.links = this.navigation.links;
        this.linksTitle = this.navigation.linksTitle;
        this.quickLinks = this.navigation.quickLinks;
        this.quickLinksTitle = this.navigation.quickLinksTitle;
        this.contact = this.infoBox.contact;
    }
}
NavigationComponent.ɵfac = function NavigationComponent_Factory(t) { return new (t || NavigationComponent)(); };
NavigationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavigationComponent, selectors: [["lib-navigation"]], inputs: { navigation: "navigation", initialTemplate: "initialTemplate" }, decls: 2, vars: 2, consts: [[4, "ngTemplateOutlet"], [4, "ngIf"], [1, "container"], [1, "row"], [1, "col-6", "left"], ["class", "navigation-quickLinks", 4, "ngIf"], ["class", "navigation-links", 4, "ngIf"], [1, "col-6", "right"], ["class", "info-box", 4, "ngIf"], [1, "navigation-quickLinks"], [3, "ngClass", "class", 4, "ngFor", "ngForOf"], [3, "ngClass"], [3, "href"], [1, "navigation-links"], [1, "info-box"], ["class", "info-box-contact", 4, "ngIf"], [1, "info-box-contact"]], template: function NavigationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NavigationComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, NavigationComponent_ng_container_1_Template, 8, 3, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.currentTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.currentTemplate);
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass], styles: [""] });
NavigationComponent.ctorParameters = () => [];
NavigationComponent.propDecorators = {
    navigation: [{ type: Input }],
    initialTemplate: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavigationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-navigation',
                template: "<ng-container *ngTemplateOutlet=\"currentTemplate\">\r\n</ng-container>\r\n<ng-container *ngIf=\"!currentTemplate\">\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-6 left\">\r\n        <div class=\"navigation-quickLinks\" *ngIf=\"quickLinks\">\r\n          <h2>{{quickLinksTitle}}</h2>\r\n          <span *ngFor=\"let qs of quickLinks;let i = index; first as isFirst; last as isLast; odd as isOdd; even as isEven\"\r\n                [ngClass]=\"[isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'']\"\r\n                class=\"link link-{{i}}\">\r\n            <a [href]=\"qs.link.url\">{{qs.link.title}}</a>\r\n          </span>\r\n        </div>\r\n        <div class=\"navigation-links\" *ngIf=\"links\">\r\n          <h3>{{linksTitle}}</h3>\r\n          <div *ngFor=\"let link of links;let i = index; first as isFirst; last as isLast; odd as isOdd; even as isEven\"\r\n               [ngClass]=\"[isLast?'last':'', isFirst?'first':'', isOdd?'odd':'', isEven?'even':'']\"\r\n               class=\"link link-{{i}}\">\r\n            <a [href]=\"link.link.url\">{{link.link.title}}</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-6 right\">\r\n        <div class=\"info-box\" *ngIf=\"infoBox!.title ||infoBox!.eMail || infoBox!.tel\">\r\n          <h2 *ngIf=\"infoBox!.title\">{{infoBox!.title}}</h2>\r\n          <p *ngIf=\"infoBox!.eMail\">{{infoBox!.eMail}}</p>\r\n          <p *ngIf=\"infoBox!.tel\">{{infoBox!.tel}}</p>\r\n          <div class=\"info-box-contact\" *ngIf=\"contact!.url\">\r\n            <a [href]=\"contact!.url\">{{contact!.title}}</a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { navigation: [{
            type: Input
        }], initialTemplate: [{
            type: Input
        }] }); })();

class NavigationModule {
}
NavigationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NavigationModule });
NavigationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NavigationModule_Factory(t) { return new (t || NavigationModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NavigationModule, { declarations: function () { return [NavigationComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NavigationComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavigationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NavigationComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    NavigationComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of navigation
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NavigationComponent, NavigationModule, NavigationService };

//# sourceMappingURL=scoop-lli-navigation.js.map